<script
  setup
  lang="ts"
  generic="FILTER_ID, FILTER_TYPE extends string, FILTER extends ActiveFilter<FILTER_TYPE, FILTER_ID>"
>
import { ActiveFilter } from "@/components/section/site-section-active-filters.types";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

const props = defineProps<{
  activeCategoryFilters: FILTER[];
  showActiveFiltersText?: boolean;
}>();

const emits = defineEmits<{
  (e: "remove-section-category", filter: FILTER): void;
}>();

const { t, k } = useTypedIntl();
</script>

<template>
  <div
    class="gap-4 flex items-center"
    :data-test-id="DATA_TEST_IDS.components.siteSectionActiveFilters.component"
  >
    <span
      v-if="props.showActiveFiltersText"
      class="text-sm font-semibold text-text-secondary"
      :data-test-id="DATA_TEST_IDS.components.siteSectionActiveFilters.text"
    >
      {{ t(k.tools.siteManagement.siteTreeStructure.activeFilters) }}
    </span>
    <div class="flex flex-wrap items-center gap-2">
      <div
        v-for="filter in activeCategoryFilters"
        :key="`${filter.type}-${filter.id}`"
        class="flex h-[30px] w-fit items-center gap-2 rounded-[12px] bg-[#f0f7ff] px-2 text-[#006aff]"
        :data-filter-id="filter.id"
        :data-test-id="DATA_TEST_IDS.components.siteSectionActiveFilters.filterItem.item"
      >
        <span
          class="text-sm font-semibold"
          :data-test-id="DATA_TEST_IDS.components.siteSectionActiveFilters.filterItem.label"
        >
          {{ filter.label }}
        </span>
        <button
          type="button"
          class="inline-flex size-4 items-center justify-center rounded text-brand hover:bg-blue-100/50"
          :data-test-id="DATA_TEST_IDS.components.siteSectionActiveFilters.filterItem.deleteButton"
          @click="emits('remove-section-category', filter)"
        >
          <i class="pi pi-times !text-xs !font-bold" />
        </button>
      </div>
    </div>
  </div>
</template>
